import React from 'react';
import { GenericEventType } from '@features/Calendar/constants';
import { useFormContext } from 'react-hook-form';
import DefaultInformation from './default-information';
import SiteVisitInformation from './site-visit-information';
function BasicInformationSection() {
    const { watch } = useFormContext();
    const formValues = watch();
    return (React.createElement("div", { className: 'basicInformationSection' },
        React.createElement(DefaultInformation, null),
        formValues.eventType === GenericEventType.Site_visit && React.createElement(SiteVisitInformation, null)));
}
export default BasicInformationSection;
